import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { registerSW } from "@/lib/registerSW";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// iter53 — Signal the prerender pipeline (@prerenderer/prerenderer) that
// the initial React tree has rendered and Helmet has committed its tags
// to <head>. The build script waits for this event before snapshotting
// so the resulting HTML contains the real per-page title / meta / JSON-LD
// instead of the boot placeholder.
if (typeof window !== "undefined") {
    // Two rAFs guarantee we've cleared the first Helmet commit tick.
    requestAnimationFrame(() => requestAnimationFrame(() => {
        document.dispatchEvent(new Event("render-event"));
    }));
}

registerSW();
